<template>
  <UiIcon
    :title="$t('ClearButton.title')"
    @click="editor.chain().focus().clearNodes().unsetAllMarks().run()"
    class="ClearButton ToolbarButton"
    value="mdi:format-clear"
  />
</template>

<script>
import useI18n from '@/modules/i18n/mixins/useI18n.js';
import { UiIcon } from '@/modules/ui/components';

export default {
  mixins: [useI18n],
  components: { UiIcon },
  props: {
    editor: {
      type: Object,
      required: true,
    },
  },

  i18n: {
    en: {
      'ClearButton.title': 'Clean formatting',
    },
    es: {
      'ClearButton.title': 'Limpieza del formato',
    },
    de: {
      'ClearButton.title': 'Saubere Formatierung',
    },
    fr: {
      'ClearButton.title': 'Formatage propre',
    },
    it: {
      'ClearButton.title': 'Formattazione pulita',
    },
    pt: {
      'ClearButton.title': 'Formatação limpa',
    },
  },
};
</script>